import React from "react"
import { H1, TextLink, Text, Image, FlexContainer } from "@carrotfertility/carotene"

const headerText = `Something’s not working`

export function ErrorPage(): JSX.Element {
  return (
    <FlexContainer title={headerText} justifyContent="center" direction="column" gap="small" alignItems="center">
      <Image src={`/images/error-sign.png`} altText="error sign" width="300px" />
      <H1 sx={{ textAlign: "center" }}>{headerText}</H1>
      <Text align="center">
        Try reloading this page. If the problem persists,
        <br /> feel free to{" "}
        <TextLink size="medium" to="/send-a-message">
          contact us
        </TextLink>
        {`.`}
      </Text>
    </FlexContainer>
  )
}
